// Elements to be observed
const sections = [
  ...document.getElementsByClassName('js-bg-change'),
  ...document.getElementsByClassName('c-columns'),
];

// Element enters the viewport else leaves viewport
const watchIt = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        document.body.style.backgroundColor =
          entry.target.dataset.backgroundColor;
      }
    });
  },
  { threshold: [0.2, 0.8] },
);

// Sections observer
if (sections) {
  sections.forEach(element => {
    const currEl = element;
    currEl.dataset.backgroundColor = element.style.backgroundColor;
    currEl.style.backgroundColor = 'transparent';
    watchIt.observe(currEl);
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/observer.js